import { RootState } from "../store";
import { createSelector } from "@reduxjs/toolkit";

const settingsSelector = (state: RootState) => state.settings.settings;
const userSelector = (state: RootState) => state.settings.user;

export const selectUnits = createSelector([settingsSelector], (settings) => settings.units);
export const selectUserSettings = createSelector([settingsSelector], (settings) => {
  return settings;
});

export const selectSettingsId = createSelector([settingsSelector], (settings) => settings.id);
export const selectUser = createSelector([userSelector], (user) => user);
export const selectFoilCCCost = createSelector([settingsSelector], (settings) => ({ foilCost: settings.foilCost, cc: settings.castAndCureCost }));
